import React from 'react'
import styles from './phoneNumberField.module.scss'
import CountryPicker from '../CountryPicker'
import ErrorIcon from '../../../icons/errorIcon.svg'
import { useTranslation } from 'react-i18next'
import cx from 'classnames'
import isNumber from '../../../utils/validators/isNumber'
import countryPickerData from '../../../constant/countryPickerData'

const PhoneNumberField = ({
  phoneNumberObj,
  errorMessage,
  onChange,
  setAnswerr,
  value,
  handleonKeyDown,
}) => {
  const handleChangeInputValue = (e) => {
    if (/^\d*$/.test(e.currentTarget.value)) {
      if (e.currentTarget.value === '' || isNumber(e.currentTarget.value)) {
        const newPhoneNumberObj = {
          ...phoneNumberObj,
          number: e.currentTarget.value,
        }
        onChange(newPhoneNumberObj)
        setAnswerr(e.currentTarget.value)
      }
    }
  }
  const handleChangeCountryCode = (countryCode, callingCode) => {
    const newPhoneNumberObj = {
      ...phoneNumberObj,
      countryCode: countryCode,
      callingCode: callingCode,
    }
    onChange(newPhoneNumberObj)
  }
  return (
    <div>
      <div
        className={cx(styles.phoneNumberField, {
          [styles.invalidInput]: errorMessage,
        })}
      >
        <CountryPicker
          countryCode={phoneNumberObj.countryCode}
          handleChangeCountryCode={handleChangeCountryCode}
        />
        <span> +{phoneNumberObj.callingCode} </span>
        <input
          placeholder={'12345678'}
          onChange={handleChangeInputValue}
          onKeyDown={(e) => {
            if (e.key === 'Enter') handleonKeyDown()
          }}
          // value={phoneNumberObj.number || value}
          value={phoneNumberObj.number}
          autoFocus
          type={'text'}
        />
      </div>
      {errorMessage && (
        <div className={styles.errorMessage}>
          <img src={ErrorIcon} alt={ErrorIcon} />
          <span>{errorMessage}</span>
        </div>
      )}
    </div>
  )
}

export default PhoneNumberField
